import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 14px 0;
    cursor: pointer;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.colorGray300};
    }

    .icon {
      width: 48px;
      border-radius: 50%;
    }
  `}
`;

export const InfoWrapper = styled.div`
  ${({ theme }) => css`
    padding: 0 16px;
    gap: 4px;
    width: 100%;

    .title {
      font-size: 16px;
      font-weight: ${theme.fontWeight.medium};
      color: ${theme.colors.colorGray500};
    }

    .subtitle {
      font-size: 14px;
      font-weight: ${theme.fontWeight.medium};
      color: ${theme.colors.colorGray400};
    }
  `}
`;
